import { render, staticRenderFns } from "./OrganizationCampaignView.vue?vue&type=template&id=2ab3d52c&scoped=true&"
import script from "./OrganizationCampaignView.vue?vue&type=script&lang=js&"
export * from "./OrganizationCampaignView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab3d52c",
  null
  
)

export default component.exports